jQuery(function($){
    $('.load-more').click(function(){

        var button = $(this),
            data = {
                'action': 'loadmore',
                'query': load_more_params.posts,
                'page' : load_more_params.current_page
            };

        $.ajax({ // you can also use $.post here
            url : load_more_params.ajaxurl,
            data : data,
            type : 'POST',
            beforeSend : function ( xhr ) {
                button.addClass('loading');
            },
            success : function( data ){
                if( data ) {
                    button.removeClass( 'loading' ).closest('.wp-block-buttons').prev().after(data);
                    load_more_params.current_page++;

                    updateArticleListSchema(data);

                    if ( load_more_params.current_page == load_more_params.max_page )
                        button.remove();
                } else {
                    button.remove();
                }
            }
        });
    });

    function updateArticleListSchema(html) {
        var schemaEl = document.getElementById('article-list-schema');
        if (!schemaEl) return;

        try {
            var schema = JSON.parse(schemaEl.textContent);
            var startPos = schema.itemListElement.length + 1;

            $(html).filter('.single-post').each(function(i) {
                schema.itemListElement.push({
                    '@type': 'ListItem',
                    'position': startPos + i,
                    'url': $(this).attr('href'),
                    'name': $(this).find('h3 span').first().text().trim()
                });
            });

            schemaEl.textContent = JSON.stringify(schema);
        } catch(e) {}
    }
});